// typeahead.js requires jquery as ES6 module
// Including it in separate js file will duplicate jquery
// we should include it in this file where main jquery is included
require("typeahead.js/dist/typeahead.jquery.min");
window.Bloodhound = require("typeahead.js/dist/bloodhound");
